<template>
	<div>
		<div class="banner">
			<!-- <div class="title">
				<div class="first">Ignite Self-Discovery </div>
				<div class="second">We're not just telling a story.</div>
			</div> -->
		</div>
		<div class="content">
			<div class="info" v-html="detail.combo"></div>
			<ul class="pack_list flex align-center justify-between">
				<li class="pact_item" v-for="(item,index) in list" :key="index">
					<div class="name">{{item.name}}</div>
					<div class="num">{{item.num}} Classes</div>
					<div class="num">{{item.describe}}</div>
					<div class="price">£{{item.price}}</div>
					<div class="num">{{item.describe_two}}</div>
					<div class="btn" @click="buy(item.id)">Buy Now</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				list:[1,2,3],
				detail:{}
			}
		},
		created(){
			this.getCourseComboList();
			this.getSystem()
		},
		methods:{
			getSystem(){
				this.$api.post('common/getsystem',{type:'sys'},res=>{
					if(res.code == 1){
						this.detail = res.data;
					}
				})
			},
			getCourseComboList(){
				this.$api.post('Course_Combo/getCourseComboList',{},res=>{
					if(res.code == 1){
						// res.data.forEach((item,index)=>{
						// 	item.price = parseInt(item.price)
						// })
						this.list = res.data;
					}
				})
			},
			buy(id){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
					return
				}
				this.$api.post('Course_Combo/submit_order',{id:id},res=>{
					if(res.code == 1){
						this.pay(res.data.order_sn)
					}
				})
			},
			pay(order_sn){
				this.$api.post('pay/stripe',{order_sn:order_sn,type:'pc'},res=>{
					if(res.code == 1){
						location.href=res.data.url
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.banner{
		width: 100%;
		height: 574px;
		background: url('../../../assets/images/home1.png') no-repeat;
		background-size: 100% 100%;
		position: relative;
		.title{
			width: 1200px;
			font-size: 70px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #FFFFFF;
			line-height: 105px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
		}
	}
	.content{
		padding-top: 30px;
		width: 1200px;
		margin: 0 auto;
		.info{
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			line-height: 24px;
			::v-deep ul{
				list-style: disc !important;
			}
			::v-deep li{
				list-style: disc !important;
			}
		}
		
		.pack_list{
			margin-top: 70px;
			flex-wrap: wrap;
			.pact_item{
				width: 380px;
				background: #F7F2EB;
				border: 2px solid #BF5F49;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 10px;
				padding: 40px 0;
				margin-bottom: 20px;
				.name{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					text-align: center;
				}
				.num{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					margin-top: 20px;
					text-align: center;
				}
				.price{
					font-size: 45px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					text-align: center;
				}
				.btn{
					width: 182px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					margin: 50px auto 0;
					line-height: 58px;
					text-align: center;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					cursor: pointer;
				}
			}
		}
	}
</style>